import { createSelector } from 'reselect'

import { RootState } from 'redux/store';
import { QASection } from 'interfaces/qa';

const selectQaSectionsMap = createSelector(
  (state: RootState) => state.qa.sectionsMap,
  (sectionsMap: Map<string, QASection>) => sectionsMap
)

export default selectQaSectionsMap
